import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isValueValid, PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.DEFINE_TEMPLATE_VARIABLES, 0> = (
  config,
  inputDataFrames
) =>
  Helpers.coalesceMessages(
    (config.variables ?? []).map((variable) =>
      isValueValid(variable.value, variable.definition as PipelineConfigJsonSpec, inputDataFrames)
        ? null
        : `Invalid value for ${variable.name && variable.name.length > 0 ? variable.name : 'variable'}`
    ),
    (config.variables ?? []).map((variable) =>
      variable.name == null || variable.name.length === 0 ? 'Name cannot be empty' : null
    )
  );

export default {
  stepType: PipelineStepType.DEFINE_TEMPLATE_VARIABLES,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.DEFINE_TEMPLATE_VARIABLES, 0>;
